import { createAction, props } from '@ngrx/store';
import { Correspondence, DossierInvoices, Templates } from './dossier-invoice.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier invoices',
    props<{ id: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier invoices success', 
    props<{ listData: DossierInvoices[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier invoices failure', 
    props<{ error: string }>()
);


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record dossier invoices',
    props<{id: string, dossierId: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record dossier invoices success', 
    props<{ singleData: any }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record dossier invoices failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier invoices',
);